module.exports = __webpack_public_path__ + "img/avatar-01-120x120.64b97391.png";